export default {
  EMAIL_INVALID: "Please use a valid email.",
  EMAIL_ALREADY_USED: "That email has already been registered.",
  INVALID_COUPON: "Invalid coupon",
  INVALID_RECIPIENT_EMAIL: "Invalid recipient email",
  LOGIN_INVALID: "Invalid username and/or password",
  NAME_INVALID: "Username must be 6-250 characters with no special characters.",
  NAME_ALREADY_USED: "That username is taken.",
  PASS_INVALID:
    "Password must be between 8 and 250 characters, and have at least one uppercase, lowercase, and special character.",
  PLEASE_SIGN_IN_WITH_GOOGLE:
    'This account uses Google sign-in. Use the "Continue with Google" button.',
  PLEASE_SIGN_IN_WITH_MICROSOFT:
    'This account uses Microsoft sign-in. Use the "Continue with Microsoft" button.',
  PLEASE_SIGN_IN_WITH_APPLE:
    'This account uses Apple sign-in. Use the "Continue with Apple" button.',
  TOKEN_INVALID: "The login token was incorrect or has expired.",
  UNABLE_RETRIEVE_COUPON: "Looks like that was an invalid coupon.",
  UNKNOWN_LOGIN: "The username or email is not recognized.",
  UNKNOWN_TOKEN: "The login token was incorrect or has expired.",
  WRONG_INFORMATION: "Incorrect login credentials"
};
